import React from 'react';
import { Loader2 } from 'lucide-react';
import PropTypes from 'prop-types';

const Loading = ({ borderColor, clientPanel, paperBackground }) => (
  <div 
    className={`
      flex items-center justify-center w-full h-full min-h-[200px] border-2 transition-all duration-300
      ${!clientPanel ? 'rounded-2xl' : 'border-transparent'}
    `}
    style={{ 
      backgroundColor: paperBackground || (clientPanel ? 'transparent' : '#EAEAEA'), 
      borderColor: !clientPanel ? (borderColor || '#DEDEDE') : 'transparent' 
    }}
  >
    <div className="flex flex-col items-center gap-4">
      <Loader2 
        size={40} 
        className="text-[#5882C1] animate-spin" 
      />
    </div>
  </div>
);

Loading.propTypes = {
  borderColor: PropTypes.string,
  clientPanel: PropTypes.bool,
  paperBackground: PropTypes.string,
};

Loading.defaultProps = {
  borderColor: '',
  clientPanel: false,
  paperBackground: '',
};

export default Loading;
